export enum PurchaseOrder {
  CzechiaVehicle = 'CzechiaVehicleOrderDto',
  FinlandVehicle = 'FinlandVehicleOrderDto',
  Nols = 'NolsOrderDto',
  Tyre = 'TyreOrderDto',
}

export const VehicleOrderTypes: readonly string[] = [
  PurchaseOrder.CzechiaVehicle,
  PurchaseOrder.FinlandVehicle,
  PurchaseOrder.Nols,
]

export const isVehicleOrderType = (type?: string | null): boolean =>
  !!type && VehicleOrderTypes.includes(type)
